/**
 * The client wants short, actionable customer notes (meeting item #11).
 * The API stores any length, so this frontend cap is the only enforcement.
 * Notes saved before the cap keep their full text: nothing here trims them.
 * Length counts UTF-16 units, so spaces count and an emoji counts as two.
 */
export const NOTES_MAX_LENGTH = 60;

export const isNoteTooLong = (notes?: string): boolean =>
  (notes?.length ?? 0) > NOTES_MAX_LENGTH;

export const notesHelperText = (notes?: string): string => {
  const counter = `${notes?.length ?? 0}/${NOTES_MAX_LENGTH} characters`;
  return isNoteTooLong(notes)
    ? `${counter}. Please shorten your note.`
    : counter;
};
